"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatesPage = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const main_1 = require("../../../../reducers/slices/main");
const document_1 = require("../../../../reducers/slices/document/document");
const create_document_thunk_1 = require("../../../../reducers/slices/document/thunks/create/create_document_thunk");
const console_1 = require("../../../../reducers/slices/console");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("../../../../constants/routes");
const get_document_thunk_1 = require("../../../../reducers/slices/document/thunks/get/get_document_thunk");
const get_templates_thunk_1 = require("../../../../reducers/slices/document/thunks/get/get_templates_thunk");
const template_preview_card_1 = require("./components/template_preview_card");
const template_upload_card_1 = require("./components/template_upload_card");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const create_document_from_file_thunk_1 = require("../../../../reducers/slices/document/thunks/create/create_document_from_file_thunk");
const document_details_modal_1 = require("./components/document_details_modal");
const constants_1 = require("../../../../constants/constants");
const TemplatesPage = () => {
    const { document_id } = (0, react_router_dom_1.useParams)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { selectedDocument, templates, isLoading } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { token } = (0, react_redux_1.useSelector)((state) => state.userState);
    (0, react_1.useEffect)(() => {
        dispatch((0, document_1.setSelectedDocument)(null));
        dispatch((0, document_1.setSelectedDocumentElements)([]));
        dispatch((0, console_1.setPageTitle)("Templates"));
        dispatch((0, console_1.setShowMenu)(true));
    }, []);
    (0, react_1.useEffect)(() => {
        //  documentDetails();
    }, []);
    const createTemplate = () => {
        dispatch((0, main_1.setContentModal)({
            title: "Template Details",
            content: (react_1.default.createElement(document_details_modal_1.DocumentDetailsModal, Object.assign({}, {
                type: constants_1.DocumentTypes.TEMPLATE,
                onSave: ({ documentName, onlySigner, signers }) => {
                    dispatch((0, create_document_thunk_1.create_document_thunk)({
                        data: {
                            name: documentName,
                            only_signer: onlySigner,
                            signers,
                            pages: 1,
                            type: constants_1.DocumentTypes.TEMPLATE,
                        },
                        callback: (data) => {
                            dispatch((0, main_1.setContentModal)(null));
                            window.open(`#${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${data._id}`, "_blank");
                        },
                    }));
                },
            }))),
        }));
    };
    (0, react_1.useEffect)(() => {
        dispatch((0, console_1.setShowMenu)(true));
        if (token) {
            getTemplate();
            if (document_id) {
                dispatch((0, get_document_thunk_1.get_document_thunk)({
                    data: {
                        _id: document_id,
                    },
                }));
            }
            else {
                dispatch((0, document_1.setSelectedDocument)(null));
                dispatch((0, document_1.setSelectedDocumentElements)([]));
            }
        }
    }, [token]);
    const handleFileSelected = (file) => {
        dispatch((0, main_1.setContentModal)({
            title: "Template Details",
            content: (react_1.default.createElement(document_details_modal_1.DocumentDetailsModal, Object.assign({}, {
                type: constants_1.DocumentTypes.TEMPLATE,
                onSave: ({ documentName, onlySigner, signers }) => {
                    if (!(documentName === null || documentName === void 0 ? void 0 : documentName.trim())) {
                        alert("Please enter a template name");
                        return;
                    }
                    dispatch((0, create_document_from_file_thunk_1.create_document_from_file_thunk)({
                        data: {
                            file: file,
                            name: documentName,
                            only_signer: onlySigner,
                            signers,
                            pages: 1,
                            status: "NONE",
                            type: "TEMPLATE",
                        },
                        callback: (data) => {
                            dispatch((0, main_1.setContentModal)(null));
                            getTemplate();
                            window.open(`#${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${data === null || data === void 0 ? void 0 : data._id}`, "_blank");
                        },
                    }));
                },
            }))),
        }));
    };
    const getTemplate = () => {
        dispatch((0, get_templates_thunk_1.get_templates_thunk)({
            data: null,
        }));
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 mb-8 px-2 sm:px-0" },
        react_1.default.createElement("div", { className: "flex justify-between" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Templates" }),
            react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faPlus, onClick: () => {
                    createTemplate();
                }, backgroundColor: "bg-secondary", borderColor: "border-secondary", iconColor: "text-white", size: "small" })),
        react_1.default.createElement("div", { className: "grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-3 lg:gap-4" },
            react_1.default.createElement(template_upload_card_1.TemplateUploadCard, { onUpload: handleFileSelected }),
            templates.map((template) => (react_1.default.createElement(template_preview_card_1.TemplatePreviewCard, Object.assign({ key: template._id }, {
                template,
                onClick: () => {
                    window.open(`#${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${template === null || template === void 0 ? void 0 : template._id}`, "_blank");
                },
            })))))));
};
exports.TemplatesPage = TemplatesPage;
